<script setup>
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  src: {
    type: String,
    required: true,
  },
  dashboardAppContext: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['load']);

/**
 * Helper: Safely access nested objects (e.g., 'contact.id')
 */
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => {
    return acc && acc[part] !== undefined ? acc[part] : null;
  }, obj);
};

// The Interpolation Logic
const iframeSrc = computed(() => {
  if (!props.src || !props.dashboardAppContext) return '';

  // Regex matches patterns like {{ contact.id }}
  return props.src.replace(/\{\{(.*?)\}\}/g, (match, path) => {
    // Remove whitespace from path (e.g. " contact.id " -> "contact.id")
    const cleanPath = path.trim();

    // Get the value from the context
    const value = getNestedValue(props.dashboardAppContext, cleanPath);

    // Return encoded value or empty string if not found
    return value !== null ? encodeURIComponent(value) : '';
  });
});

const handleLoad = () => {
  emit('load');
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <iframe
    v-if="iframeSrc"
    :id="id"
    :key="iframeSrc"
    :src="iframeSrc"
    @load="handleLoad"
  />
</template>

<style scoped>
iframe {
  height: 100%;
  width: 100%;
  border: 0;
}
</style>
